import { ListItemCard } from '@components/display/cards';
import { VictronImage } from '@components/display/images';
import { LanguageLabel } from '@components/utility/labels/LanguageLabel/LanguageLabel';
import { Box, Typography } from '@mui/material';
import { OnlineTrainingCourseListItem } from '@onlineTraining/types/onlineTraining';
import { formatVideoDuration } from '@onlineTraining/utils/onlineTraining';
import { FormattedMessage } from 'react-intl';

interface IOnlineTrainingListCard {
    course?: OnlineTrainingCourseListItem;
    loading?: boolean;
    className?: string;
}

export const OnlineTrainingListCard = ({ course, loading, className }: IOnlineTrainingListCard) => {
    if (loading || !course) {
        return <ListItemCard loading className={className} />;
    }

    return (
        <ListItemCard
            className={className}
            image={
                <>
                    <VictronImage
                        src={course.video.thumbnail_url}
                        alt={course.title}
                        className="w-full h-full rounded object-contain"
                    />
                    <Box
                        bgcolor="#030303"
                        position="absolute"
                        right={10}
                        bottom={10}
                        paddingX={0.5}
                        paddingY="2px"
                        borderRadius="1px"
                    >
                        <Typography fontFamily="Roboto" fontSize={13} fontWeight={500} color="#FFFFFF">
                            {formatVideoDuration(course.video.duration)}
                        </Typography>
                    </Box>
                </>
            }
            title={course.title}
            subtitle={
                <FormattedMessage
                    id="onlineTraining.byTrainer"
                    defaultMessage="By {trainers}"
                    values={{ trainers: course.trainers }}
                />
            }
            metadataItems={(course.available_languages?.length ? course.available_languages : [course.language]).map(
                (language) => (
                    <LanguageLabel key={language.code} langCode={language.code} langLabel={language.name} />
                )
            )}
            actionLabel={
                <FormattedMessage
                    id="onlineTraining.actions.startTraining"
                    defaultMessage="Start Training"
                    description="Button text to view navigate to the course details page"
                />
            }
            linkTo={`/app/online-training/${course.id}`}
        />
    );
};
